import { IconButton, lighten, Theme } from "@mui/material";
import { Description } from "@mui/icons-material";
import { useAlert } from "../../../context/AlertContext";
import { useTranscriptDownload } from "../../../hooks/useTranscription";

interface DownloadTranscriptButtonProps {
  customerId: string;
  interactionId: string;
  disabled?: boolean;
}

export function DownloadTranscriptButton({
  customerId,
  interactionId,
  disabled = false,
}: DownloadTranscriptButtonProps) {
  const showAlert = useAlert();
  const {
    mutateAsync: downloadTranscriptAsync,
    isPending,
    error,
  } = useTranscriptDownload();

  async function handleClick() {
    try {
      await downloadTranscriptAsync({ customerId, interactionId });
    } catch (error: unknown) {
      console.error(error);
      showAlert("Failed to download transcript.", "error");
    }
  }

  const isError = Boolean(error);

  function iconColor(theme: Theme) {
    if (isError) {
      if (disabled) {
        return lighten(theme.palette.error.main, 0.5);
      }
      return theme.palette.error.main;
    }
    if (disabled || isPending) {
      return theme.palette.action.disabled;
    }
    return "inherit";
  }

  return (
    <IconButton
      onClick={handleClick}
      disabled={isError || disabled || isPending}
    >
      <Description
        sx={{
          color: iconColor,
        }}
      />
    </IconButton>
  );
}
